declare global {
  let ga: any;
  let dataLayer: any;
}

class GaTriggerEventFactory {
  constructor(...props) {
    return () => {
      if (props.length === 0) {
        return;
      }
      const [category, action, label] = props;

      if (typeof dataLayer !== 'undefined') {
        const dataLayerData = {
          event: 'category',
          action,
          label: label | action,
        };
        dataLayer.push(dataLayerData);
      }

      if (typeof ga !== 'undefined') {
        ga('send', 'event', category, action, label | action);
      }
    };
  }
}

export default GaTriggerEventFactory;
